'use client';
import { ButtonStylesReset } from '@s7/base';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getStyles = function(theme, param) {
    var visited = param.visited, underline = param.underline, color = param.color, visitedColor = param.visitedColor, focusColor = param.focusColor, transitionDuration = param.transitionDuration;
    var visitedShade = theme.fn.primaryShade(theme.fn.themeColor(visitedColor, theme.palette.text.secondary));
    var visitableShade = function(shade) {
        return visited === true ? visitedShade : shade;
    };
    var base = theme.fn.primaryShade(theme.fn.themeColor(color));
    var states = theme.fn.deriveStates(base, "color");
    return _extends({
        textDecoration: underline === "always" ? "underline" : "none"
    }, theme.fn.focusRing({
        color: theme.fn.primaryShade(theme.fn.themeColor(focusColor, theme.palette.primary.mid))
    }), transitionDuration && theme.fn.transition({
        props: "color",
        fn: "ease-in-out",
        duration: transitionDuration
    }), color && function() {
        return {
            color: visitableShade(base),
            "&:hover": {
                color: states.hover
            },
            "&:active": {
                color: states.active
            }
        };
    }(), visited && _extends({
        "&:visited": {
            color: visitedShade
        }
    }, visitedColor && {
        "&[data-visited=true]": {
            color: visitedShade,
            "&:hover": {
                color: visitedShade
            },
            "&:active": {
                color: visitedShade
            }
        }
    }), {
        "&:hover": {
            color: visitableShade(states.hover),
            textDecoration: underline === "hover" ? "underline" : undefined
        },
        "&:active": {
            color: visitableShade(states.active)
        }
    });
};
var useStyles = createStyles(function(theme, _param, _) {
    var breakpoints = _param.breakpoints, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({}, ButtonStylesReset, {
            boxSizing: "border-box",
            appearance: "none",
            cursor: "pointer",
            borderRadius: 2
        }, getStyles(theme, params), theme.fn.responsive(breakpoints)(function(localParams) {
            return getStyles(theme, localParams);
        }))
    };
});

export { useStyles as default };
